import { render, staticRenderFns } from "./DeleteCuponModal.vue?vue&type=template&id=4e567c70"
import script from "./DeleteCuponModal.vue?vue&type=script&lang=js"
export * from "./DeleteCuponModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports